import SubLabel from "components/Atoms/Sublabel";
import { FormSection } from "components/MainSectionTemplate/types";
import CompanyModalPicker from "components/Picker/CompanyPicker/CompanyModalPicker";
import ContactModalPicker from "components/Picker/ContactPicker/ContactModalPicker";
import { ContactPreview } from "components/PreviewPanel/contact/ContactPreviewPanel";
import { CompanySmallDetails } from "components/SmallDetails";
import React from "react";
import { useContact } from "utilities/hookutils";

interface Props {
  contact: server.dto.ContactSmallV2
  contactEmail: string
  company: server.dto.CompanySmall
  clientId: number
}

export const billingDetailsSection = (props: Props): FormSection => {
  const { contact, contactEmail, company, clientId } = props
  return {
    key: "billingDetails",
    type: "regular",
    title: "Billing details",
    fields: [
      {
        key: "billingCompany",
        label: "Company",
        render: () => <CompanySmallDetails
          company={company}
          layout="multiLine" />,
        inPageEdit: {
          render: ({ onChange }) => <div className="main-section-template-fields-padding">
            <CompanyModalPicker
              modalTitle="Select company"
              addressType="administrative"
              value={null}
              onChange={v => onChange(v, true)}
              validatorKey="billingCompany"
              required={false}
              canCreateNew
            />
          </div>,
          fullWidth: false,
          type: "custom",
          initialValue: company,
          submitChange: async (c) => window.CoreApi.Client.UpdateCompany({ companyId: c.companyId, clientId })
        }
      }, {
        key: "billingContact",
        label: "Finance contact",
        render: () => <ContactRow contact={contact} email={contactEmail} />,
        inPageEdit: {
          render: ({ onChange }) => <div className="main-section-template-fields-padding">
            <ContactModalPicker
              startOpen
              value={null}
              onChange={v => onChange(v, true)}
              required={false}
              validatorKey="billingContact"
              canCreateNew={false}
            />
          </div>,
          fullWidth: false,
          type: "custom",
          initialValue: contact,
          submitChange: async (c) => window.CoreApi.Client.UpdateContact({ contactId: c.contactId, clientId })
        }
      }
    ]
  }
}

const ContactRow = (props: { contact: server.dto.ContactSmallV2, email: string }) => {
  const contact = useContact(props.contact);
  return <div>
    <div>
      <ContactPreview contactId={contact.contactId} trigger={<a>{contact.name.fullName}</a>} />
    </div>
    <SubLabel>{props.email}</SubLabel>
  </div>
}
